import React, { useEffect, useState } from "react";
import StaffStrengthIns from "./SMInsertionType/StaffStrengthIns";
import axios from "axios";
import OfficerIns from "./SMInsertionType/OfficerIns";
import SpecialWorkIns from "./SMInsertionType/SpecialWorkIns";
import LayoutIns from "./SMInsertionType/LayoutIns";
import OfficerUpdate from "./SMInsertionType/OfficerUpdate";
import LayoutUpdate from "./SMInsertionType/LayoutUpdate";
import SpecialWorkUpdate from "./SMInsertionType/SpecialWorkUpdate";
import StaffStrengthUpdate from "./SMInsertionType/StaffStrengthUpdate";

const SMInsMaster = () => {
  const [active, setActive] = useState("Staff Strength Insert");
  const [sec, setSec] = useState("");
  const [stn, setStn] = useState("");

  const [stations, setStations] = useState([]);
  const [stationsList, setStationsList] = useState([]);

  const section = [...new Set(stations.map((o) => o.section))];
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const urlBlockPrefix = process.env.REACT_APP_URL_BLOCK_PREFIX;

  const fetchstation = async () => {
    try {
      const response = await axios.get(`${urlBlockPrefix}getstationcode`);
      if (response.data.status === "ok") {
        setStations(response.data.data);
      }
    } catch (err) {
      console.error("Failed to fetch stations", err);
      setError(true);
    }
  };

  useEffect(() => {
    fetchstation();
  }, []);
  const fetchData1 = async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `https://railsetu.in:5020/station-details-filter?section=${sec}`
      );
      if (response.data.status === "ok") {
        setStationsList(response.data.data);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch stations:", error);
      setLoading(false);
      setError(true);
    }
  };

  useEffect(() => {
    fetchData1();
  }, [sec]);
  return (
    <div style={{ minHeight: "90vh" }} className="papaDiv">
      <h5 className="p-2 bg-dark text-white text-center">
        Insert Data in Station Mapping
      </h5>

      {/* <div className="d-flex justify-content-center  mt-5">
        <select
          className="form-select rounded-pill text-center mb-3 w-25"
          value={sec}
          onChange={(e) => setSec(e.target.value)}
        >
          <option value="" hidden>
            Select Section
          </option>
          {section.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>
        <select
          className="form-select rounded-pill text-center mb-3 w-25"
          value={stn}
          onChange={(e) => setStn(e.target.value)}
        >
          <option value="" hidden>
            Select Station
          </option>
          {stationsList.map((s) => (
            <option key={s.station_code} value={s.station_id}>
              {s.station_code}
            </option>
          ))}
        </select>
      </div> */}

      <div className="row d-flex justify-content-between papaDiv">
        <div className="d-flex justify-content-center m-2">
          <button
            onClick={() => {
              setActive("Staff Strength Insert");
            }}
            className={`btn btn-sm btn-outline-dark me-1 ${
              active === "Staff Strength Insert" && "active"
            }`}
          >
            Staff Strength Insert
          </button>
          <button
            onClick={() => {
              setActive("Staff Strength Update");
            }}
            className={`btn btn-sm btn-outline-info me-1 ${
              active === "Staff Strength Update" && "active"
            }`}
          >
            Staff Strength Update
          </button>
          <button
            onClick={() => {
              setActive("Staff Layout Insert");
            }}
            className={`btn btn-sm btn-outline-dark me-1 ${
              active === "Staff Layout Insert" && "active"
            }`}
          >
            Layout Insert
          </button>{" "}
          <button
            onClick={() => {
              setActive("Staff Layout Update");
            }}
            className={`btn btn-sm btn-outline-info me-1 ${
              active === "Staff Layout Update" && "active"
            }`}
          >
            Layout Update
          </button>{" "}
          <button
            onClick={() => {
              setActive("Special Work");
            }}
            className={`btn btn-sm btn-outline-dark me-1 ${
              active === "Special Work" && "active"
            }`}
          >
            Special Work Insert
          </button>{" "}
          <button
            onClick={() => {
              setActive("Special Work Update");
            }}
            className={`btn btn-sm btn-outline-info me-1 ${
              active === "Special Work Update" && "active"
            }`}
          >
            Special Work Update
          </button>{" "}
          <button
            onClick={() => {
              setActive("Officer Insert");
            }}
            className={`btn btn-sm btn-outline-dark me-1 ${
              active === "Officer Insert" && "active"
            }`}
          >
            Officer Insert
          </button>{" "}
          <button
            onClick={() => {
              setActive("Officer Update");
            }}
            className={`btn btn-sm btn-outline-info me-1 ${
              active === "Officer Update" && "active"
            }`}
          >
            Officer Update
          </button>{" "}
          <hr />
        </div>
        <div>
          {" "}
          <div className="d-flex justify-content-center  mt-5">
            <select
              className="form-select rounded-pill text-center mb-3 me-2 w-25"
              value={sec}
              onChange={(e) => setSec(e.target.value)}
            >
              <option value="" hidden>
                Select Section
              </option>
              {section.map((s) => (
                <option key={s} value={s}>
                  {s}
                </option>
              ))}
            </select>
            <select
              className="form-select rounded-pill text-center ms-2 mb-3 w-25"
              value={stn}
              onChange={(e) => setStn(e.target.value)}
            >
              <option value="" hidden>
                Select Station
              </option>
              {stationsList.map((s) => (
                <option key={s.station_code} value={s.station_id}>
                  {s.station_code}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
      <div className="row">
        {active === "Staff Layout Insert" && <LayoutIns Id={stn} />}
        {active === "Staff Layout Update" && <LayoutUpdate Id={stn} />}
        {active === "Staff Strength Insert" && <StaffStrengthIns Id={stn} />}
        {active === "Staff Strength Update" && <StaffStrengthUpdate Id={stn} />}
        {active === "Officer Insert" && <OfficerIns Id={stn} />}
        {active === "Officer Update" && <OfficerUpdate Id={stn} />}
        {active === "Special Work" && <SpecialWorkIns Id={stn} />}
        {active === "Special Work Update" && <SpecialWorkUpdate Id={stn} />}
      </div>
    </div>
  );
};
export default SMInsMaster;
